(() => {
  if (window.CeelikeNhapLanding) return;

  const state = {
    revealObserver: null,
    purchaseObserver: null,
    finalObserver: null,
    purchaseVisible: true,
    finalVisible: false
  };

  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const updateMobileBar = () => {
    const bar = document.querySelector('[data-nhap-mobile-bar]');
    if (!bar) return;

    const shouldShow = window.innerWidth < 768 && !state.purchaseVisible && !state.finalVisible;
    bar.classList.toggle('is-visible', shouldShow);
    bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  };

  const initReveal = (root = document) => {
    const items = root.querySelectorAll('[data-nhap-reveal]:not([data-nhap-ready])');
    if (!items.length) return;

    if (reducedMotion() || !('IntersectionObserver' in window)) {
      items.forEach((item) => {
        item.dataset.nhapReady = 'true';
        item.classList.add('is-visible');
      });
      return;
    }

    state.revealObserver ||= new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    items.forEach((item, index) => {
      item.dataset.nhapReady = 'true';
      item.style.transitionDelay = `${Math.min(index % 4, 3) * 70}ms`;
      state.revealObserver.observe(item);
    });
  };

  const initScrollLinks = (root = document) => {
    root.querySelectorAll('[data-nhap-scroll-to-product]:not([data-nhap-scroll-ready])').forEach((link) => {
      link.dataset.nhapScrollReady = 'true';
      link.addEventListener('click', (event) => {
        const productSection = document.querySelector('[data-nhap-product-section]');
        if (!productSection) return;
        event.preventDefault();
        productSection.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
        window.setTimeout(() => productSection.querySelector('[data-add-to-cart]')?.focus({ preventScroll: true }), reducedMotion() ? 0 : 650);
      });
    });
  };

  const initReviewCarousels = (root = document) => {
    root.querySelectorAll('[data-nhap-review-track]:not([data-nhap-review-ready])').forEach((track) => {
      const section = track.closest('.nhap-review-stories');
      const previous = section?.querySelector('[data-nhap-review-prev]');
      const next = section?.querySelector('[data-nhap-review-next]');
      const status = section?.querySelector('[data-nhap-review-status]');
      if (!previous || !next || !status) return;

      track.dataset.nhapReviewReady = 'true';

      const metrics = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const pageWidth = Math.max(1, track.clientWidth);
        const total = Math.max(1, Math.ceil(track.scrollWidth / pageWidth));
        const current = Math.min(total, Math.max(1, Math.round(track.scrollLeft / pageWidth) + 1));
        return { maxScroll, pageWidth, total, current };
      };

      const update = () => {
        const { maxScroll, total, current } = metrics();
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll - 2;
        status.textContent = `${current} / ${total}`;
      };

      const move = (direction) => {
        const { pageWidth } = metrics();
        track.scrollBy({ left: direction * pageWidth, behavior: reducedMotion() ? 'auto' : 'smooth' });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  };

  const initMobileBar = () => {
    state.purchaseObserver?.disconnect();
    state.finalObserver?.disconnect();

    const purchaseButton = document.querySelector('[data-nhap-product-section] [data-add-to-cart]');
    const finalSection = document.querySelector('[data-nhap-final]');
    if (!purchaseButton || !('IntersectionObserver' in window)) {
      updateMobileBar();
      return;
    }

    state.purchaseObserver = new IntersectionObserver(([entry]) => {
      state.purchaseVisible = entry.isIntersecting || entry.boundingClientRect.top > 0;
      updateMobileBar();
    }, { threshold: 0.15 });
    state.purchaseObserver.observe(purchaseButton);

    if (finalSection) {
      state.finalObserver = new IntersectionObserver(([entry]) => {
        state.finalVisible = entry.isIntersecting;
        updateMobileBar();
      }, { threshold: 0.1 });
      state.finalObserver.observe(finalSection);
    }
  };

  const init = (root = document) => {
    initReveal(root);
    initScrollLinks(root);
    initReviewCarousels(root);
    initMobileBar();
  };

  window.CeelikeNhapLanding = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.addEventListener('resize', updateMobileBar, { passive: true });
})();
